import HttpRequest from './http_request'
import { getStoreBearer } from '@/utils/helper/localStorage'

class OrderProvider extends HttpRequest {
  constructor () {
    super(process.env.SELLSUKI_URL)
  }
  async posCompleteCart (params) {
    this.setHeader({
      'Authorization': await getStoreBearer()
    })
    const { data: { results } } = await this.create('/bill/poscompletecart', params.data)
    return results
  }

  async init () {
    this.setHeader({
      'Authorization': await getStoreBearer()
    })
    const { data } = await this.get('/init')
    const billExpire = data.results.store.default_bill_expire_day
    const paymentChannel = data.results.store_payment_channel.map(payment => ({
      id: payment.spc.id,
      payment_name: payment.pc.name,
      payment_channel_id: payment.spc.payment_channel_id,
      logo: payment.pc.logo
    }))
    return {
      billExpire,
      paymentChannel,
      initData: data.results
    }
  }
}

export default OrderProvider



// WEBPACK FOOTER //
// ./src/resources/order_provider.js